<template>
  <div class="w-full h-full overflow-y-auto">
    <el-form class="w-600px m-auto my-0" :model="form" ref="formRef">
      <el-form-item label="支持框架" prop="supportFramework">
        <select-support-framework v-model="form.supportFramework" @item-click="frameworkClick"></select-support-framework>
      </el-form-item>
      <el-form-item label="应用场景" prop="applicationScenario">
        <wise-select v-model="form.applicationScenario"></wise-select>
      </el-form-item>
      <el-form-item label="支持硬件">
        <div class="flex flex-wrap support-hardware-parent">
          <div v-for="item in $store.state.selectOptions.supportHardware" :key="item.id" style=""
            class="support-hardware h-43px leading-43px rounded-5px px-15px mr-11px mt-11px" :class="{
              'bg-pri': form.supportHardware.includes(item.id)
            }" @click="supportHardwareClick(item.id)">
            {{ item.name }}
          </div>
        </div>
      </el-form-item>
      <el-form-item label="支持工具软件">
        <wise-select v-model="form.supportToolSoftware" :options="$store.state.selectOptions.supportToolSoftware"
          placeholder="请选择支持工具软件"></wise-select>
      </el-form-item>
      <el-form-item label="模型标签">
        <div class="flex items-center">
          <tag :tags="form.modelOverview" @delete="deleteLabel" @confirm="addTagConfirm" ref="tag" />
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import selectSupportFramework from '@/components/select-support-framework.vue'
import wiseSelect from '@/components/wise-select.vue'
import tag from '@/components/tag.vue'

export default {
  components: { selectSupportFramework, wiseSelect, tag },
  model: {
    prop: 'form',
    event: 'setForm'
  },
  props: {
    form: {},
    id: {} // 模型id
  },
  data() {
    return {
      formRule: {
        supportFramework: [
          {
            required: true,
            message: '请选择支持框架',
            trigger: 'change'
          }
        ]
      },
      applicationScenarioOptions: [{ label: '协议', value: 1 }],
      supportOptions: [
        {
          label: '支持',
          value: 0
        },
        {
          label: '不支持',
          value: 1
        }
      ]
    }
  },
  watch: {
    // 支持框架data 变动 重新校验该字段
    'form.supportFramework'(val) {
      this.$refs['formRef'].validateField('supportFramework')
    }
  },
  created() { },
  mounted() { },
  methods: {
    // 支持硬件 item点击
    supportHardwareClick(id) {
      const index = this.form.supportHardware.findIndex((item) => item === id)
      if (index > -1) {
        this.form.supportHardware.splice(index, 1)
      } else {
        this.form.supportHardware.push(id)
      }
    },
    // 支持框架 item点击
    frameworkClick(item) {
      const { id } = item
      if (this.form.supportFramework.includes(id)) {
        this.form.supportFramework.splice(
          this.form.supportFramework.findIndex((item) => item === id),
          1
        )
      } else {
        this.form.supportFramework.push(id)
      }
    },
    // 自定义添加标签确定事件
    addTagConfirm(value) {
      this.$api.project
        .addlabel({
          name: value
        })
        .then((res) => {
          if (res.message === 'Success') {
            this.form.modelOverview.push({
              name: value,
              id: res.data
            })
            this.$refs.tag.finishAdd()
          }
        })
        .finally(() => {
          this.$refs.tag.finishAdd()
        })
    },
    // 删除标签
    deleteLabel({ index }) {
      this.form.modelOverview.splice(index, 1)
    }
  }
}
</script>
<style lang="scss" scoped>

.support-hardware-parent {
  margin-top: -11px;

  .support-hardware {
    border: 1px solid #e1dce9;
  }
}

.tags {
  margin-top: -11px;
}

</style>
